import React from "react";
// eslint-disable-next-line
import { Routes, Route } from "react-router-dom";
import Layout from "../v2/Layout";

const Navigation = () => {
  return (
    <Routes>
      <Route path="/*" element={<Layout />} />
    </Routes>
  );
};

export default Navigation;
